module.exports = __webpack_public_path__ + "img/logo-cis-solo.37526566.svg";